import React, { Component } from "react";
import { Image } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import NoDataFound from "../../component/NoDataFound";
import { isValidArray } from "../../helper";

export default class KeyEnablersResponsive extends Component {
  state = {
    keyFeatures: [
      {
        title: "Dashboard",
        description:
          "The PMG portal provides a summary of the projects and their issues on a dashboard. All the relevant stakeholders will be able to view the progress of the project and download reports."
      },
      {
        title: "Track Issues Status",
        description:
          "     The PMG portal allows for real-time monitoring and status\n" +
          "                  updating in the issue resolution process. All the stakeholders\n" +
          "                  can track the issue resolution process across stages."
      },
      {
        title: "Follow-Up",
        description:
          "PMG conducts periodic meetings at the state and ministry\n" +
          "                  levels to identify bottlenecks in projects and understand\n" +
          "                  their status by engaging with all the stakeholders."
      },
      {
        title: "Feedback",
        description:
          "The PMG portal allows project proponents as well state and\n" +
          "                  ministry officials to provide feedback on the issue resolution\n" +
          "                  mechanism and can also offer comments on specific issues."
      },
      {
        title: "Notifications",
        description:
          "The PMG portal posts the latest notifications for the\n" +
          "                  stakeholders to have updated information on the project and\n" +
          "                  their issues."
      }
    ]
  };

  render() {
    const { keyFeatures } = this.state;
    let settings = {
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2.5
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.5
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };
    return (
      <React.Fragment>
        <h2 className="key-enabler-heading">Key Features</h2>
        <div className="latestnews-wrapper" id="features">
          <div className="container">
            <Slider {...settings} className="latestnews">
              {isValidArray(keyFeatures) ? (
                keyFeatures.map((news, index) => {
                  return (
                    <div
                      className="slide-item latestnews-card"
                      key={`news-${index}`}
                    >
                      <div className="latestnews-data">
                        <div className="news-title">{news.title}</div>
                        <div
                          className="news-desc"
                          dangerouslySetInnerHTML={{ __html: news.description }}
                        />
                      </div>
                    </div>
                  );
                })
              ) : (
                <NoDataFound />
              )}
            </Slider>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
